import React from 'react'
import IPText from '../../IPText'
import EntryTime from '../../PositionColumns/EntryTime'

export const column_ip = mutate => {
	return [
		{
			title: '시간',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 140,
			align: 'center',
			render: (text, record) => {
				return <EntryTime time={record?.created_at} />
			},
		},
		{
			title: 'IP',
			dataIndex: 'ip',
			key: 'ip',
			width: 300,
			align: 'left',
			render: (text, record) => {
				return <IPText ip={text} mutate={mutate} />
			},
		},
	]
}
